import Horn from '@utils/horn';
import * as Ids from '@utils/ids';
import { getStorage, setStorage } from '@utils/localStorage';

interface INotificationHornConfig {
    /** 非重要消息提醒白名单配置 */
    weakNotification: string[];
    /** 重要消息提醒白名单配置 */
    strongNotification: string[];
    /** 订单推送白名单配置 */
    orderNotification: string[];
    /** IM消息白名单配置 */
    imNotification: string[];
}

interface INotificationLocalConfig {
    /** 账号ID */
    acctId: string;
    /** 是否接收非重要消息提醒 */
    weakNotification?: boolean;
    /** 是否接收重要消息提醒 */
    strongNotification?: boolean;
    /** 是否接收订单推送 */
    orderNotification?: boolean;
    /** 是否接收IM消息 */
    imNotification?: boolean;
}

enum IMessageType {
    /** IM消息 */
    CUSTOM_MESSAGE = 'imNotification',
    /** 订单消息 */
    ORDER_MESSAGE = 'orderNotification',
    /** 重要消息提醒 */
    IMPORT_MESSAGE = 'strongNotification',
    /** 非重要消息提醒 */
    OTHER_MESSAGE = 'weakNotification',
}

const MESSAGE_CACHE_KEY = 'MESSAGE_NOTIFICATION_CONFIG';

/**
 * 获取消息提醒配置, localStorage中的配置优先级高于horn中配置
 */
const getMessageConfig = () => {
    const cacheInfoStr = getStorage(MESSAGE_CACHE_KEY) || '[]';
    let cacheInfo: INotificationLocalConfig[] = [];
    const acctId = Ids.getAcctId();
    try {
        cacheInfo = JSON.parse(cacheInfoStr);
    } catch (e) {
        //
    }
    let acctIdMessageConfig: INotificationLocalConfig = { acctId };
    // 取出horn中的配置
    const hornMessageConfig = Horn.getConfigByFieldName<INotificationHornConfig>(
        Horn.CONFIG_FIELD.NOTIFICATION_CONFIG,
    );

    if (hornMessageConfig) {
        const {
            weakNotification,
            strongNotification,
            orderNotification,
            imNotification,
        } = hornMessageConfig;
        if (weakNotification.includes(acctId)) acctIdMessageConfig.weakNotification = false;
        if (strongNotification.includes(acctId)) acctIdMessageConfig.strongNotification = false;
        if (orderNotification.includes(acctId)) acctIdMessageConfig.orderNotification = false;
        if (imNotification.includes(acctId)) acctIdMessageConfig.imNotification = false;
    }

    // 取出localStorage中的配置
    const cacheInfoIds = cacheInfo.map(item => item.acctId);
    if (cacheInfoIds.includes(acctId)) {
        acctIdMessageConfig = Object.assign(
            acctIdMessageConfig,
            cacheInfo.filter(item => item.acctId === acctId)[0],
        );
    }
    return acctIdMessageConfig;
};

/**
 * 更新localStotage中该账号下的某一消息类型的状态
 * @param type 消息类型
 * @param status 消息状态
 */
const setMessageConfig = (type: IMessageType, status: boolean) => {
    const acctId = Ids.getAcctId();
    const cacheInfoStr = getStorage(MESSAGE_CACHE_KEY) || '[]';
    let cacheInfo: INotificationLocalConfig[] = [];
    const newAcctIdSetting: INotificationLocalConfig = { acctId };
    newAcctIdSetting[type] = status;

    try {
        cacheInfo = JSON.parse(cacheInfoStr);
    } catch (e) {
        //
    }
    // 取出localStorage中的配置
    const acctidInfoIndex = cacheInfo.findIndex(item => item.acctId === acctId);
    if (acctidInfoIndex > -1) {
        cacheInfo[acctidInfoIndex][type] = status;
    } else {
        // 不存在该账号下的消息
        cacheInfo = cacheInfo.concat([newAcctIdSetting]);
    }

    setStorage(MESSAGE_CACHE_KEY, JSON.stringify(cacheInfo));

    // 避免开关切换动作没有执行完就刷新
    setTimeout(() => {
        window.top.location.reload();
    }, 200);
};

export { getMessageConfig, setMessageConfig, IMessageType };
